import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  ViewChild,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { DatePicker } from 'primeng/datepicker';
import { Paginator } from 'primeng/paginator';
import { Select } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TableBaseAbstractComponent } from '../../../../../../../shared/components/table-base-abstract.component';
import { PreviewDataWrapperComponent } from '../../../../../../../shared/components/preview-data-wrapper/preview-data-wrapper.component';
import { ConstLabelReaderPipe } from '../../../../../../../shared/pipes/const-label-reader.pipe';
import {
  AUTHENTICATION_METHOD_LABELS,
  AuthenticationMethod,
  getAuthenticationMethodDropdownItems,
} from '../../../../../../../shared/enums/authentication-method.enum';
import { AdminPanelUserDetails } from '../../../../../../../shared/models/admin-panel-user-details';
import { AdminPanelUserLoginHistoryEntry } from '../../../../../../../shared/models/admin-panel-user-login-history-entry';
import { TableRequestData } from '../../../../../../../shared/models/table/table-request-param';
import { TableResponse } from '../../../../../../../shared/models/table-response';
import { AdminPanelUsersApi } from '../../../../../../../shared/services/api/admin-panel-users.api';

@Component({
  selector: 'app-admin-panel-user-logins-table',
  imports: [
    Button,
    Card,
    DatePicker,
    DatePipe,
    FormsModule,
    Paginator,
    PreviewDataWrapperComponent,
    Select,
    ConstLabelReaderPipe,
    TableModule,
  ],
  templateUrl: './admin-panel-user-logins-table.component.html',
  styleUrl: './admin-panel-user-logins-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserLoginsTableComponent extends TableBaseAbstractComponent<AdminPanelUserLoginHistoryEntry> {
  @ViewChild('table') override tableRef!: Table;

  readonly #adminPanelUsersApi = inject(AdminPanelUsersApi);

  userDetails = input.required<AdminPanelUserDetails>();
  protected readonly AUTHENTICATION_METHOD_LABELS = AUTHENTICATION_METHOD_LABELS;
  protected readonly authenticationMethodOptions = getAuthenticationMethodDropdownItems();
  protected tableFilters = {
    loginAt: null as Date | null,
    authenticationMethod: null as AuthenticationMethod | null,
  };

  constructor() {
    super();
    this.tableRequest.update((value) => ({
      ...value,
      pageSize: 5,
    }));
  }

  protected override apiCall$ = (
    params: TableRequestData,
  ): Observable<TableResponse<AdminPanelUserLoginHistoryEntry>> => {
    return this.#adminPanelUsersApi.getUserLoginHistory$(
      this.userDetails(),
      params,
    );
  };

  protected clearFilters(): void {
    this.tableFilters = {
      loginAt: null,
      authenticationMethod: null,
    };
    this.resetFilters();
  }
}

